import DashboardSysAdmin from "./dashboardSysAdmin"
import Permit from "../../util/permit"
import DashboardBuildingDirector from "./dashboardBuildingDirector"
import DashboardBuildingManager from "./dashboardBuildingManager"
import DashboardOwner from "./dashboardOwner"
import DashboardReceptionist from "./dashboardReceptionist"
import DashboardAccountant from "./dashboardAccountant"
import { NavLink } from "react-router-dom"

export default function Dashboard() {
    //TODO: Each of these have nested permits that include role and hence are redundant
    //TODO: the `noPermittedServiceMessage` also needs to be added to these permit tags
    //TODO: and not in the child components
    return (
        <Permit
            roles="SYSAD,BLDIR,BLDMG,REC,OWN,CS"
            // services="PREMIUM,CORE,LEAN"
            noPermittedServiceMessage={{
                title: "Access Denied",
                body: (
                    <div>
                        Your do not have a role permitted to view this
                        page. <br/> Please contact your system admin if you feel this is an
                        error. <br/>
                        <br/>

                        <NavLink
                            to="/listings"
                            style={{
                                textDecoration: "none",
                                color: "white",
                                backgroundColor: "#037171",
                                padding: "5px 10px",
                                borderRadius: "5px",
                            }}
                        >
                            Go to Listings
                        </NavLink>
                    </div>
                ),
            }}
        >
            <Permit roles="SYSAD" proxy={false}>
                <DashboardSysAdmin/>
            </Permit>
            <Permit roles="ACC,SYSAD" proxy={true}>
                <DashboardAccountant/>
            </Permit>
            <Permit roles="BLDIR,SYSAD" proxy={true}>
                <DashboardBuildingDirector/>
            </Permit>
            <Permit roles="BLDMG,SYSAD,CS" proxy={true}>
                <DashboardBuildingManager/>
            </Permit>
            <Permit roles="OWN,SYSAD" proxy={true}>
                <DashboardOwner/>
            </Permit>
            <Permit roles="REC,SYSAD" proxy={true}>
                <DashboardReceptionist/>
            </Permit>
        </Permit>
    )
}
